
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

import ProgressBarPercentage from "../components/ProgressBarPercentage";

const ProfileCompletion = () =>{
    
    return(
        <div className="card">
            <div className="card-header">
                <h5 className="mb-0">Profile Completion</h5>
            </div>
            <div className="card-block">
                <div className="table-resposive">
                    <table className="table table-bordered table-hover">
                        <tr>
                            <td>Basic Info</td>
                            <td>
                                <ProgressBarPercentage />
                            </td>
                        </tr>
                        <tr>
                            <td>Default Setting</td>
                            <td>
                                <ProgressBarPercentage />
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    );
}


export default ProfileCompletion;